import { render } from "./OurCoreServiceAboutUs.vue?vue&type=template&id=1d3b7594&scoped=true"
import script from "./OurCoreServiceAboutUs.vue?vue&type=script&lang=js"
export * from "./OurCoreServiceAboutUs.vue?vue&type=script&lang=js"

import "./OurCoreServiceAboutUs.vue?vue&type=style&index=0&id=1d3b7594&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d3b7594"]])

export default __exports__